import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getEntriesAndDeparturesService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values);
        const response = await customFetch(`${API_URL}reports/accessEgress`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}
export const getResourceDetailToReportService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}reports/movementDetail?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}
export const downloadEntryAndDepartureReportService = async (values) => {
    try {

        const configs = getConfigExactian('POST', values);

        const response = await customFetch(`${API_URL}reports/exportToExcel`, configs);

        const resData = await response.blob();

        if (!response.ok) {
            return {
                ok: false,
                data: response,
            };
        } else {
            return {
                ok: true,
                data: resData,
            };
        }

    } catch (error) {
        console.log(error)
    }
}

export const downloadEntryAndDepartureReportServicePDF = async (values) => {
    try {

        const configs = getConfigExactian('POST', values);

        const response = await customFetch(`${API_URL}reports/exportToPDF`, configs);

        const resData = await response.blob();

        if (!response.ok) {
            return {
                ok: false,
                data: response,
            };
        } else {
            return {
                ok: true,
                data: resData,
            };
        }

    } catch (error) {
        console.log(error)
    }
}
export const editEntryOrDepartureService = async (values) => {
    try {
        const configs = getConfigExactian('PUT', values);
        const response = await customFetch(`${API_URL}access`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}
